import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Replace these with your Firebase config values
const firebaseConfig = {
  apiKey: "AIzaSyB-7BS4rLIWdrqotUrnAdC2_cEiISMIUoc",
  authDomain: "aitomato-9d467.firebaseapp.com",
  projectId: "aitomato-9d467",
  storageBucket: "aitomato-9d467.firebasestorage.app",
  messagingSenderId: "295598784545",
  appId: "1:295598784545:web:a138c6bf63830ed0b76360"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app); 